import React from "react";
import "./upperCard.css";

export default function UpperCard(props) {
  return <h1 className="titleCsr">{props.title}</h1>;
}
